import { safeParse } from "@/utils/safeParse";
import reporter from "../report/reporter";
import { getSearchData } from "../shared/getSearchData";
import { getPage } from "../shared/global";
import { getAttribute, getFilter } from "./get";

/**在data-*属性上的埋点数据 */
const trackerDataAttrs = {
  // 点击相关内容数据
  pin_id: "data-content-id",
  board_id: "data-board-id",
  content_id: "data-material-id",
  file_id: "data-file-id",
  search_word: "data-search-word",
  content_type: "data-content-type",
  // 内容分类：模板还是元素材
  content_category: "data-content-category",
  // 用户类型
  user_type: "data-user-type",

  // 瀑布流屏蔽相关数据
  report_reason: "data-report-reason",
  report_type: "data-report-type",
  report_user_id: "data-report-user-id",
  report_content_id: "data-report-content-id",
  report_pin_id: "data-report-pin-id",
  report_domain_id: "data-report-domain-id",
  is_tag: "data-is-tag",

  // 关注数据
  concern_object_id: "data-concern-object-id",
  concern_object_type: "data-concern-object-type",
  concern_object_name: "data-concern-object-name",
};

/**获取埋点数据 */
function getTrackerData(targetNode, { other = {} } = {}) {
  const page = getPage();
  const filter = getFilter(page.page_nm);

  const trackData = {
    button_name: targetNode.getAttribute("data-button-name"),
    ...page,
    ...other,
  };

  Object.keys(trackerDataAttrs).forEach((key) => {
    const value = getAttribute(targetNode, trackerDataAttrs[key]);
    if (value) {
      trackData[key] = value;
    }
  });

  const { page_nm, sub_page_nm } = page;
  const source =
    getAttribute(targetNode, "data-content-source") ||
    getAttribute(targetNode, "data-dialog-title");

  if (source) {
    if (filter.filter_one && filter.filter_one.length > 0) {
      trackData.button_source = `${page_nm}_${sub_page_nm || ""}_${
        filter.filter_one[0]
      }_${source}`;
    } else {
      trackData.button_source = `${page_nm}_${sub_page_nm || ""}_${source}`;
    }
  } else {
    if (filter.filter_one && filter.filter_one.length > 0) {
      trackData.button_source = sub_page_nm
        ? `${page_nm}_${sub_page_nm}_${filter.filter_one[0]}`
        : `${page_nm}_${filter.filter_one[0]}`;
    } else {
      trackData.button_source = sub_page_nm
        ? `${page_nm}_${sub_page_nm}`
        : page_nm;
    }
  }

  if (page_nm === "搜索结果页" || page_nm === "采集详情页") {
    getSearchData(trackData);
  }

  const ext = getAttribute(targetNode, "data-ext");
  if (ext) {
    Object.assign(trackData, safeParse(ext));
  }

  if (["关注页", "个人关注页", "新人引导页"].includes(page_nm)) {
    const dist_code = getAttribute(targetNode, "data-dist-code");
    if (dist_code) {
      trackData.dist_code = dist_code;
    }
  }

  const coupon_ids = getAttribute(targetNode, "data-coupon-ids");
  if (coupon_ids) {
    trackData.coupon_ids = coupon_ids.split(",");
  }

  const content_category = getAttribute(targetNode, "data-content-category");
  if (content_category) {
    trackData.content_category = content_category;
  }

  const subject_name = getAttribute(targetNode, "data-subject-name");
  if (subject_name) {
    trackData.subject_name = subject_name;
  }

  const module_name = getAttribute(targetNode, "data-module-name");
  if (module_name) {
    trackData.module_name = module_name;
  }

  const apply_client = getAttribute(targetNode, "data-apply-client");
  if (apply_client) {
    trackData.apply_client = apply_client;
  }

  if (getAttribute(targetNode, "data-iscopyright")) {
    trackData.is_copyright_material = 1;
  }

  return trackData;
}

/**
 * 按钮点击事件
 * @param {Element} targetNode
 * @param {Object} other
 */
export function button_click(targetNode, { other = {} } = {}) {
  const basicData = {
    event_id: 39008,
    event_name: "button_click",
  };

  const trackerData = getTrackerData(targetNode, { other });

  const isEdit = getAttribute(targetNode, "data-is-edit");
  if (isEdit) {
    trackerData.is_edit = +isEdit || 0;
  }

  const isTag = getAttribute(targetNode, "data-is-tag");
  if (isTag) {
    trackerData.is_tag = +isTag || 0;
  }

  reporter({
    ...basicData,
    ...trackerData,
  });
}

/**
 * 按钮曝光
 * @param {Element} targetNode
 * @param {Object} other
 */
export function button_expose(targetNode, { other = {} } = {}) {
  const basicData = {
    event_id: 39024,
    event_name: "button_expose",
  };

  const trackerData = getTrackerData(targetNode, { other });

  reporter({
    ...basicData,
    ...trackerData,
  });
}
